<template>
  <div
    @click="isMonthlyPlanDisabled ? null : $emit('update-selected-plan', plan)"
    :class="[
      'plan',
      isPlanSelected && 'plan__selected',
      isMonthlyPlanDisabled && 'plan__disabled',
    ]"
  >
    <img
      v-if="isPremiumPlusPlan"
      src="@/assets/images/subscriptions/snipe_best_value.png"
      class="plan__snipe"
      alt="Best Value"
    />
    <p class="plan__name">{{ cleanName(plan.name) }}</p>
    <p class="plan__price">{{ cleanPrice(plan.price) }}</p>
    <p class="plan__term">
      per
      {{ plan.merchant_id === 'fundamentals_monthly' ? 'month' : plan.term }}
    </p>
    <div class="plan__details-wrapper">
      <p
        v-for="detail in details"
        :key="`detail-${detail.name}`"
        class="plan__detail"
      >
        <span
          :class="[
            'plan__flair',
            detail.checked ? 'plan__flair--checked' : 'plan__flair--unchecked',
          ]"
        ></span>
        <span :class="[detail.checked ? '' : 'plan__flair--unchecked-text']">{{
          detail.name
        }}</span>
      </p>
    </div>
    <button
      :disabled="isMonthlyPlanDisabled"
      :class="[
        'btn',
        'btn--secondary',
        'plan__btn',
        !isPlanSelected &&
          selectedPlan &&
          selectedPlan.merchant_id &&
          'plan__btn--unselected',
        isPlanSelected && 'btn--active',
      ]"
    >
      {{ isPlanSelected ? 'Selected Plan' : 'Select Plan' }}
    </button>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import CONSTANTS from '@/constants'

export default {
  name: 'Plan',
  props: {
    plan: {
      type: Object,
      required: true,
    },
    hasMonthlyPlan: {
      type: Boolean,
      required: true,
    },
    details: {
      type: Array,
      required: true,
    },
    selectedPlan: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      monthlyPlanCode: CONSTANTS.PLANS.MONTHLY,
      yearlyPlanCode: CONSTANTS.PLANS.ANNUAL,
    }
  },
  computed: {
    ...mapState({
      premiumPlanCode: state => state.subscriptions.premiumPlanCode,
    }),
    isPremiumPlusPlan() {
      return this.plan?.merchant_id === CONSTANTS.PLANS.PREMIUM_PLANS[3]
    },
    isMonthlyPlanDisabled() {
      const {
        hasMonthlyPlan,
        plan: { merchant_id },
        monthlyPlanCode,
      } = this
      return hasMonthlyPlan && merchant_id && merchant_id === monthlyPlanCode
    },
    isPlanSelected() {
      return this.selectedPlan && this.selectedPlan.name === this.plan.name
    },
  },
  methods: {
    cleanName(name) {
      if (name === 'Premium Defense Bundle') return 'Premium+'
      return name.replace('Individual', '')
    },
    cleanPrice(price) {
      const priceParts = price.split('.')
      return priceParts[1] === '00' ? priceParts[0] : price
    },
  },
}
</script>

<style lang="scss">
.plan {
  text-align: center;
  color: var(--white);
  background: rgba(38, 38, 38, 0.6);
  position: relative;
  border-radius: 10px;
  border: 3px solid transparent;
  transition: 0.5s;
  padding: 10px;
  width: 100%;
  max-width: 610px;
  flex: 1 0 25%;
  margin: 5px 0;
  cursor: pointer;
  @include mobile {
    padding: 25px 20px;
    padding-bottom: 50px;
    width: auto;
  }
  &__selected {
    border-color: var(--orange);
  }
  &__disabled {
    opacity: 0.4;
    cursor: default;
  }
  &__snipe {
    position: absolute;
    right: 0;
    top: 0;
    max-height: 100px;
    @include mobile {
      max-height: 75px;
    }
    @include tablet {
      max-height: 100px;
    }
  }
  &__name {
    font-size: rem(28px);
    margin: 0 0 15px 0;
    padding: 0;
    width: 100%;
    text-transform: capitalize;
    font-family: var(--font-bold);
    @include desktop {
      margin: 0 0 38px 0;
    }
    @include mobile {
      min-height: 100px;
    }
  }
  &__price {
    margin: 0 0 15px 0;
    padding: 0;
    width: 100%;
    font-family: var(--font-bold);
    font-size: rem(40px);
    @include desktop {
      font-size: rem(50px);
    }
  }
  &__term {
    text-transform: uppercase;
    color: var(--lighter-gray);
    font-size: rem(14px);
    margin: 0;
    padding: 0;
    width: 100%;
    font-family: var(--font-bold);
  }
  &__details-wrapper {
    margin: 15px 0;
    @include desktop {
      margin: 50px 0;
    }
  }
  &__detail {
    padding: 0;
    margin: 10px 0;
    display: flex;
    align-items: center;
    font-family: var(--font-bold);
    width: 100%;
    text-align: start;
    font-size: rem(14px);
    @include desktop {
      font-size: rem(18px);
    }
  }
  &__flair {
    pointer-events: none;
    position: relative;
    margin: 0 10px 0 0;
    border: 1px solid var(--lighter-gray);
    width: 20px;
    font-size: rem(14px);
    flex: none;
    &--checked {
      &:before {
        display: block;
        content: '\2713';
        text-align: center;
        color: var(--green);
      }
    }
    &--unchecked {
      &:before {
        display: block;
        content: '\2716';
        text-align: center;
        color: var(--lighter-gray);
      }
    }
    &--unchecked-text {
      color: var(--emperor-gray);
    }
  }
  &__btn {
    color: var(--white);
    border-color: var(--orange);
    &--unselected {
      --btn-secondary-text-color: var(--lighter-gray);
      --btn-border-color: var(--lighter-gray);
    }
    @include mobile {
      position: absolute;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
</style>
